import { SearchQuery } from "shared/data/reducers/types/storage";
import { HotelOfferDetail } from "shared/types/hotels";

const filterHotelPrice = (searchQuery: SearchQuery) => (
  hotel: HotelOfferDetail
): boolean => {
  const price = Number(
    hotel.RoomCategoriesInfo?.AlternativeCurrencyRoomCategoryPerNightPriceRange
      ?.PriceFromWithServiceFee ||
      hotel.RoomCategoriesInfo?.RoomCategoryPerNightPriceRange
        ?.PriceFromWithServiceFee ||
      0
  );

  const min = searchQuery.hotelLowestPrice
    ? Number(searchQuery.hotelLowestPrice)
    : undefined;
  const max = searchQuery.hotelHighestPrice
    ? Number(searchQuery.hotelHighestPrice)
    : undefined;

  if (min !== undefined && price < min) {
    return false;
  }

  if (max !== undefined && price > max) {
    return false;
  }

  return true;
};

export default filterHotelPrice;
